import { TFunction } from "next-i18next";

import { ParcelWeight } from "../constants";
import { TParcelWeight } from "../types";

const getParcelWeights = (t: TFunction): TParcelWeight[] => [
    {
        value: ParcelWeight.S1,
        label: t("order-package-parcel_weight-less-than-10kg"),
    },
    {
        value: ParcelWeight.S2,
        label: t("order-package-parcel_weight-10-20kg"),
    },
    {
        value: ParcelWeight.S3,
        label: t("order-package-parcel_weight-more-than-20kg"),
    },
];
export default getParcelWeights;
